import { client } from '../../..'
import { DeleteChangeMutation } from '../../../types'
import ChangeQueriesAndMutations from '../ChangeQueriesAndMutations'
import { FLEXIBLE_BONUS_BY_EMPLOYEE_ID_IN_AS_MEETING } from '../../../modules/appraisal/appraisal-flow/shared/appraisal-components/Queries'
import { FetchResult, MaybeMasked } from '@apollo/client'

const mutateDeleteChange = (changeId: number, employeeId: number, meetingId: number): Promise<FetchResult<MaybeMasked<unknown>>> => {
  return client.mutate<DeleteChangeMutation>({
    mutation: ChangeQueriesAndMutations.DeleteChange,
    variables: {
      changeId: changeId,
      employeeId: employeeId,
    },
    refetchQueries: [
      {
        query: ChangeQueriesAndMutations.OpenContractChanges,
        variables: {
          id: employeeId,
        },
      },
      {
        query: FLEXIBLE_BONUS_BY_EMPLOYEE_ID_IN_AS_MEETING,
        variables: {
          employeeId,
          meetingId,
        },
      },
    ],
    awaitRefetchQueries: true,
  })
}

export default (
  employeeId: number,
  meetingId: number,
): { deleteChange: (changeId: number) => Promise<FetchResult<MaybeMasked<unknown>>> } => {
  const deleteChange = async (changeId: number) => {
    const { data, errors } = await mutateDeleteChange(changeId, employeeId, meetingId)
    return { data, errors }
  }

  return {
    deleteChange,
  }
}
